export default () => {
    const $editorialAssets = $(".js-editorial-assets");
    const prevArrowPositionSpacing = 60;

    if ($editorialAssets.length) {
        $editorialAssets.each((index, carousel) => {
            const $carousel = $(carousel);

            $carousel.on("init", (evt, slick) => {
                // Arrows of the slider on large screens must be between last active slide and the next one
                // On initialization of the slider I'm calculating the correct position for the arrows
                const $activeSlide = slick.$slides.filter(".slick-active:last");
                const isSideBySide = $carousel.closest(".editorial-container__side-by-side-wrapper").length > 0;

                if ($activeSlide.length && !isSideBySide) {
                    const leftPos = $activeSlide.offset().left + $activeSlide.outerWidth(true);
                    const $slideParent = $activeSlide.parents(".slick-slider");

                    if (slick.$prevArrow && slick.$prevArrow.length && slick.$nextArrow && slick.$nextArrow.length) {
                        slick.$prevArrow.css("left", leftPos - prevArrowPositionSpacing);
                        slick.$nextArrow.css("left", leftPos);

                        // updathe the class on load
                        ArrowsOutOfBounds($slideParent, leftPos);

                        // handle the position on resize
                        $(window).on("resize", window.debounce(() => {
                            if (slick.$prevArrow.length) {
                                slick.$prevArrow.css("left", leftPos - prevArrowPositionSpacing);
                            }

                            if (slick.$nextArrow.length) {
                                slick.$nextArrow.css("left", leftPos);
                            }
                            ArrowsOutOfBounds($slideParent, leftPos);
                        }, 100));
                    }
                }
            });

            $carousel.slick({
                autoplay: false,
                mobileFirst: true,
                arrows: false,
                dots: true,
                slidesToShow: 1.0005,
                infinite: false,
                responsive: [
                    {
                        breakpoint: 769,
                        settings: $carousel.closest(".is-desktop-carousel").length ? {
                            dots: false,
                            arrows: true,
                            slidesToShow: parseFloat($carousel.attr("data-slides-to-show"))
                        } : "unslick",
                    }
                ],
            });
        });
    }
};

/**
* Checks if the left position of the slide parent is out of bounds and adds/removes a class accordingly
* @param {jQuery} $slideParent - the jQuery object representing the parent element of the slide
* @param {number} parentWidth - the width of the parent element
* @param {number} leftPos - the left position of the slide
* @returns {void}
*/
function ArrowsOutOfBounds($slideParent, leftPos) {
    const outOfBoundsClass = "slick-slider--arrows-out-of-bounds";
    let parentWidth = $slideParent.width();

    if (parentWidth < leftPos) {
        $slideParent.addClass(outOfBoundsClass);
    } else {
        $slideParent.removeClass(outOfBoundsClass);
    }
}
